<template>
  <div class="row frameTransmissao" v-if="item._id !== ''">
    <div v-bind:class="propColunas">
      <h3>{{ this.item.nome }}</h3>

      <hr />

      <h6
        v-bind:style="{
          display: item.servidorTipo == 'ant' ? 'block' : 'none',
        }"
      >
        {{
          this.item.status
            ? "Canal " + this.item.canalTransmissao + " criado"
            : "Clique para criar a transmissão"
        }}
      </h6>

      <h6 v-if="retornaSite() == 'Share' || retornaSite() == '7live'">
        {{
          this.item.status
            ? "Transmissão iniciada!"
            : "Selecione a fonte e clique em iniciar"
        }}
      </h6>

      <div
        class="d-flex justify-content-center"
        style="margin-bottom: 10px"
        v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
        v-bind:style="{
          display: item.servidorTipo == 'ant' ? 'block' : 'none!important',
        }"
      >
        <Combo
          :itens="[
            { id: '1', nome: '1' },
            { id: '2', nome: '2' },
            { id: '3', nome: '3' },
            { id: '4', nome: '4' },
            { id: '5', nome: '5' },
            { id: '6', nome: '6' },
            { id: '7', nome: '7' },
            { id: '8', nome: '8' },
            { id: '9', nome: '9' },
            { id: '10', nome: '10' },
            { id: '11', nome: '11' },
            { id: '12', nome: '12' },
            { id: '0', nome: '0' },
          ]"
          style="max-width: 100px"
          :disabled="item.status"
          v-model="item.canal"
        />
      </div>

      <div
        class="row"
        v-bind:style="{ display: item.servidorTipo == 'ant' ? 'flex' : 'none' }"
      >
        <div class="col">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            style="min-height: 53px; min-width: 65px"
            @click="rtmp()"
          >
            RTMP
          </button>
        </div>
        <div
          class="col"
          v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
        >
          <button
            type="button"
            class="btn btn-outline-dark btn-sm"
            style="min-height: 53px; min-width: 65px"
            @click="abrirFonte()"
          >
            Fonte
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-outline-success btn-sm"
            style="min-height: 53px; min-width: 65px"
            @click="abrirEvento('1')"
          >
            Player
          </button>
        </div>
        <div
          class="col"
          v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
        >
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            style="min-height: 53px; min-width: 65px"
            @click="novoCanal()"
          >
            Novo Canal
          </button>
        </div>
      </div>

      <div
        class="d-flex justify-content-center flex-wrap"
        style="margin-bottom: 15px"
        v-bind:style="{
          display:
            item.servidorTipo == 'openvidu' ||
            item.servidorTipo == 'ms' ||
            item.servidorTipo == 'sh'
              ? 'flex'
              : 'none',
        }"
        v-if="
          (retornaSite() !== 'Share' && retornaSite() !== '7live') ||
          (retornaSite() == '7live' && avancado)
        "
      >
        <div
          style="padding-left: 5px; padding-right: 5px; margin-top: 10px"
          v-for="(canal, keyCanal) in canais"
          :key="keyCanal"
          :item="canal"
        >
          <div>
            <button
              type="button"
              class="btn btn-sm"
              v-bind:class="{
                'btn-outline-secondary': !canal.status,
                'btn-secondary': canal.status,
              }"
              style="min-width: 45px; zoom: 80%"
              @click="transmissaoCanal(false, keyCanal)"
              :disabled="
                viewPreview == '' ||
                (viewPreview == 'preview' && item.tabLive == false) ||
                canal.enabled == false
              "
            >
              {{ keyCanal }}
            </button>
          </div>
          <div style="margin-top: 10px">
            <button
              type="button"
              class="btn btn-sm"
              v-bind:class="{
                'btn-outline-secondary': !canal.status,
                'btn-secondary': canal.status,
              }"
              style="min-width: 45px; zoom: 80%"
              data-toggle="modal"
              data-target="#modalCanal"
              @click="editarCanal(keyCanal)"
              :disabled="
                item.servidorTipo == 'ms' &&
                keyCanal == '0' &&
                canal.enabled == false
                  ? true
                  : false
              "
            >
              {{ $global.servidores_sip()[canal.servidor].nome }}
            </button>
          </div>
        </div>
      </div>

      <hr
        v-bind:style="{
          display:
            (item.servidorTipo == 'openvidu' ||
              item.servidorTipo == 'ms' ||
              item.servidorTipo == 'sh') &&
            retornaSite() !== 'Share' &&
            retornaSite() !== '7live'
              ? 'block'
              : 'none',
        }"
      />

      <h6
        style="margin-bottom: 15px"
        v-bind:style="{
          display:
            (item.servidorTipo == 'openvidu' ||
              item.servidorTipo == 'ms' ||
              item.servidorTipo == 'sh') &&
            viewPreview == ''
              ? 'block'
              : 'none',
        }"
      >
        Escolha o tipo de preview para iniciar a transmissão
      </h6>

      <div
        class="d-flex justify-content-center"
        v-bind:style="{
          display:
            (item.servidorTipo == 'openvidu' ||
              item.servidorTipo == 'ms' ||
              item.servidorTipo == 'sh') &&
            viewPreview == ''
              ? 'flex'
              : 'none!important',
        }"
      >
        <button
          type="button"
          class="btn btn-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          @click="viewPreview = 'preview'"
        >
          Com preview
        </button>
        <button
          type="button"
          class="btn btn-dark btn-sm"
          style="min-height: 35px; min-width: 65px"
          @click="viewPreview = 'not-preview'"
        >
          Sem preview
        </button>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-bind:style="{
          display:
            (item.servidorTipo == 'openvidu' ||
              item.servidorTipo == 'ms' ||
              item.servidorTipo == 'sh') &&
            viewPreview == 'preview'
              ? 'flex'
              : 'none',
        }"
      >
        <div class="col">
          <div class="btn-group btn-group-sm" role="group" aria-label="">
            <button
              type="button"
              class="btn"
              v-bind:class="{
                'btn-outline-primary': item.abaTransmissaoVideo !== 'preview',
                'btn-primary': item.abaTransmissaoVideo == 'preview',
              }"
              style="min-width: 83px"
              @click="abaTransmissaoVideo('preview')"
            >
              Preview
            </button>
            <button
              type="button"
              :disabled="!item.tabLive"
              class="btn"
              v-bind:class="{
                'btn-outline-primary': item.abaTransmissaoVideo !== 'live',
                'btn-primary': item.abaTransmissaoVideo == 'live',
              }"
              style="min-width: 83px"
              @click="abaTransmissaoVideo('live')"
            >
              Live
            </button>
          </div>
        </div>
      </div>

      <div
        style="margin-bottom: 20px"
        class="row"
        v-bind:style="{
          display:
            item.servidorTipo == 'openvidu' ||
            item.servidorTipo == 'ms' ||
            item.servidorTipo == 'sh'
              ? 'flex'
              : 'none',
        }"
      >
        <div class="col">
          <div class="">
            <div
              id="containerVideos"
              style="margin-top: 10px; display: none"
            ></div>
            <div
              style="margin-top: 5px"
              v-bind:style="{
                display:
                  item.abaTransmissaoVideo == 'preview' ||
                  viewPreview == 'not-preview'
                    ? 'block'
                    : 'none',
              }"
            >
              <div class="d-flex justify-content-center">
                <button
                  type="button"
                  class="btn btn-outline-dark btn-sm"
                  style="
                    margin-right: 10px;
                    zoom: 80%;
                    height: 30px;
                    margin-top: 10px;
                  "
                  v-bind:style="{
                    display: viewPreview == 'preview' ? 'block' : 'none',
                  }"
                  @click="livePreview()"
                  :disabled="!item.previewAberto"
                >
                  Publish
                </button>
                <Combo
                  :itens="item.dispositivosVideo"
                  v-model="item.dispositivoVideo"
                  style="width: auto"
                  v-bind:style="{
                    display: viewPreview !== '' ? 'block' : 'none',
                  }"
                />
                <button
                  type="button"
                  class="btn btn-outline-dark btn-sm"
                  style="
                    margin-left: 10px;
                    zoom: 80%;
                    height: 30px;
                    margin-top: 10px;
                  "
                  v-bind:style="{
                    display: viewPreview == 'preview' ? 'block' : 'none',
                  }"
                  @click="definirCompartilhamento()"
                >
                  Select
                </button>
              </div>

              <div id="containerPreview" style="margin-top: 10px"></div>

              <div
                class="row"
                style="margin-top: 10px"
                v-bind:style="{
                  display: item.previewAberto ? 'block' : 'none',
                }"
              >
                <div class="col d-flex justify-content-center">
                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Top</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropTopo"
                  />

                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Bottom</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropRodape"
                  />

                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Left</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropEsquerda"
                  />

                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Right</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropDireita"
                  />

                  <button
                    type="button"
                    class="btn btn-outline-dark btn-sm"
                    style="
                      margin-right: 10px;
                      zoom: 80%;
                      height: 30px;
                      margin-top: 7px;
                    "
                    @click="cropPreview(true)"
                  >
                    -
                  </button>

                  <button
                    type="button"
                    class="btn btn-outline-dark btn-sm"
                    style="zoom: 80%; height: 30px; margin-top: 7px"
                    @click="cropPreview()"
                  >
                    Crop
                  </button>
                </div>
              </div>
            </div>
            <div
              v-bind:style="{
                display:
                  item.abaTransmissaoVideo == 'live'
                    ? 'block!important'
                    : 'none!important',
              }"
            >
              <div
                id="containerLive"
                class="d-flex justify-content-center"
                v-bind:style="{
                  display:
                    item.servidorTipo == 'openvidu' ||
                    item.servidorTipo == 'ms' ||
                    item.servidorTipo == 'sh'
                      ? 'flex'
                      : 'none!important',
                }"
                style="margin-top: 10px"
              ></div>

              <div
                id="publishFlash"
                class="d-flex justify-content-center"
                v-bind:style="{
                  display:
                    item.servidorTipo == 'sh2' ? 'flex' : 'none!important',
                }"
                style="margin-top: 25px"
              ></div>

              <div class="row" style="margin-top: 10px">
                <div class="col d-flex justify-content-center">
                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Top</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropTopoLive"
                  />

                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Bottom</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropRodapeLive"
                  />

                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Left</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropEsquerdaLive"
                  />

                  <h6 style="margin-right: 10px; margin-top: 10px">
                    <small>Right</small>
                  </h6>
                  <input
                    class="form-control input-sm"
                    type="text"
                    style="margin-right: 10px; max-width: 60px"
                    v-model="item.cropDireitaLive"
                  />

                  <button
                    type="button"
                    class="btn btn-outline-dark btn-sm"
                    style="
                      margin-right: 10px;
                      zoom: 80%;
                      height: 30px;
                      margin-top: 7px;
                    "
                    @click="cropLive(true)"
                  >
                    -
                  </button>

                  <button
                    type="button"
                    class="btn btn-outline-dark btn-sm"
                    style="zoom: 80%; height: 30px; margin-top: 7px"
                    @click="cropLive()"
                  >
                    Crop
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-bind:style="{
          display:
            item.servidorTipo == 'ms' && item.dispositivoVideo == 'sharescreen'
              ? 'flex'
              : 'none',
        }"
      >
        <div class="col">
          <div
            style="margin-bottom: 10px"
            class="d-flex justify-content-center"
          >
            <button
              type="button"
              class="btn btn-sm"
              v-bind:class="{
                'btn-outline-secondary': true,
              }"
              style="min-width: 65px; zoom: 80%"
              @click="carregarEventosRemoto()"
            >
              Carregar eventos
            </button>
          </div>
          <div class="d-flex justify-content-center">
            <Combo
              :itens="item.eventosRemoto"
              v-model="item.eventoRemoto"
              style="width: auto"
              v-bind:style="{
                display: viewPreview !== '' ? 'block' : 'none',
              }"
            />
          </div>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-bind:style="{
          display:
            item.servidorTipo == 'ms' && item.dispositivoVideo !== 'sharescreen'
              ? 'flex'
              : 'none',
        }"
      >
        <div class="col d-flex justify-content-center">
          <div class="dropdown">
            <button
              class="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButtonAudio"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{
                item.dispositivoAudio == "false"
                  ? "Sem áudio"
                  : dispositivosAudioObj[item.dispositivoAudio].nome
              }}
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButtonAudio"
            >
              <a
                v-for="(
                  dispositivoAudio, keyDispositivoAudio
                ) in item.dispositivosAudio"
                :key="keyDispositivoAudio"
                :item="dispositivoAudio"
                class="dropdown-item"
                type="button"
                @click="item.dispositivoAudio = dispositivoAudio.id"
                >{{ dispositivoAudio.nome }}</a
              >
            </div>
          </div>

          <!-- <Combo
          :itens="item.dispositivosAudio"
          v-model="item.dispositivoAudio"
          style="max-width:200px;display:none"
          /> -->
        </div>
      </div>

      <hr
        v-bind:style="{
          display: item.servidorTipo == 'ant' ? 'block' : 'none',
        }"
      />

      <div
        class="row"
        style="margin-top: 20px"
        v-bind:style="{ display: item.servidorTipo == 'ant' ? 'flex' : 'none' }"
      >
        <div class="col-sm-12">
          <div>
            <h6><b>RTMP Endereço</b></h6>
          </div>
          <div>
            <h6>{{ item.rtmpLink }}</h6>
          </div>
          <div>
            <h6><b>RTMP Chave</b></h6>
          </div>
          <div>
            <h6>{{ item.rtmpChave }}</h6>
          </div>
        </div>
      </div>

      <hr
        style="margin-top: 5px"
        v-bind:style="{
          display:
            item.servidorTipo == 'openvidu' ||
            item.servidorTipo == 'ms' ||
            item.servidorTipo == 'sh'
              ? 'block'
              : 'none',
        }"
      />

      <div
        style="margin-bottom: 20px"
        class="d-flex justify-content-center"
        v-bind:style="{
          display:
            item.servidorTipo == 'openvidu' ||
            item.servidorTipo == 'ms' ||
            item.servidorTipo == 'sh'
              ? 'flex'
              : 'none!important',
        }"
      >
        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          @click="transmissao(false, '1')"
          v-if="
            (item.servidorTipo == 'ant' ||
              retornaSite() == 'Share' ||
              retornaSite() == '7live') &&
            !avancado
          "
        >
          {{ this.item.status ? "Parar" : "Iniciar" }}
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
          @click="abrirFonte()"
        >
          Fonte
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          data-toggle="modal"
          data-target="#modalPlayer"
          v-if="
            (retornaSite() !== 'Share' &&
              retornaSite() !== '7live' &&
              retornaSite() !== 'Weddbets') ||
            (retornaSite() == '7live' && avancado)
          "
        >
          Player
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          @click="abrirEvento('1')"
          v-if="
            retornaSite() == 'Share' || (retornaSite() == '7live' && !avancado)
          "
        >
          Player
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
          @click="novoCanal()"
        >
          Transmissão
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          @click="permissaoDevices()"
        >
          Devices
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          @click="avancado = !avancado"
          v-if="retornaSite() == '7live' && !avancado"
          :disabled="item.status"
        >
          Avançado
        </button>

        <button
          type="button"
          class="btn btn-outline-dark btn-sm"
          style="min-height: 35px; min-width: 65px; margin-right: 10px"
          @click="avancado = !avancado"
          v-if="retornaSite() == '7live' && avancado"
          :disabled="
            canais['0'] &&
            canais['1'] &&
            (canais['0'].status || canais['1'].status)
          "
        >
          Normal
        </button>
      </div>

      <div
        class="d-flex justify-content-center flex-wrap"
        style="margin-left: 5px"
        v-if="retornaSite() == 'Weddbets'"
      >
        <div
          style="margin-right: 5px; margin-top: 3px"
          v-for="(canal, keyCanal) in canais"
          :key="keyCanal"
          :item="canal"
        >
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="abrirEvento(keyCanal)"
          >
            {{ keyCanal }}
          </button>
        </div>
      </div>

      <div
        class="modal fade"
        id="modalCanal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document" style="max-width: 1000px">
          <div class="modal-content">
            <div class="modal-header">
              <h6
                class="modal-title"
                v-if="canalEdicao !== ''"
                id="modalCanalLabel"
              >
                Canal {{ canalEdicao }}
              </h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div
                class="d-flex justify-content-center flex-wrap"
                style="margin-left: 5px; margin-rigth: 5px"
                v-if="canalEdicao !== ''"
              >
                <div
                  style="margin-right: 5px; margin-left: 5px; margin-top: 5px"
                  v-for="(servidor, keyServidor) in servidoresTipo"
                  :key="keyServidor"
                  :item="servidor"
                >
                  <button
                    type="button"
                    class="btn btn-sm"
                    v-bind:class="{
                      'btn-outline-primary':
                        canais[canalEdicao].servidor !== keyServidor,
                      'btn-primary':
                        canais[canalEdicao].servidor == keyServidor,
                    }"
                    @click="alterarCanalServidor(keyServidor)"
                    data-dismiss="modal"
                  >
                    {{ servidor.nome }}
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="modalPlayer"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="modalCanalLabel">Player</h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div
                class="d-flex justify-content-center"
                style="margin-left: 5px"
              >
                <div
                  style="margin-right: 5px"
                  v-for="(canal, keyCanal) in canais"
                  :key="keyCanal"
                  :item="canal"
                >
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="abrirEvento(keyCanal)"
                  >
                    {{ keyCanal }}
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";
import util from "../includes/util.js";

import Combo from "../components/Combo.vue";

export default {
  name: "TransmitEvento",
  components: { Combo },
  props: {
    propView: { type: String, default: "modal" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12", "text-center"];
      },
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    permissaoDevices() {
      window.navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then(() => {
          //window.navigator.mediaDevices.getUserMedia();
          window.document.location.reload();
        });
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      const response = await api.get("/evento/" + id);

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];

        this.item._id = itemEdit._id;
        this.item.nome = itemEdit.nome;
        this.item.servidor = itemEdit.servidor;
        this.item.servidorTipo = itemEdit.servidorTipo
          ? itemEdit.servidorTipo
          : "openvidu";
        this.item.linkFonte = itemEdit.linkFonte;
        this.item.status = false;
        this.item.canal = "1";
        this.item.canalTransmissao = "";
        this.item.cropTopo = "0";
        this.item.cropRodape = "0";
        this.item.cropEsquerda = "0";
        this.item.cropDireita = "0";
        this.item.cropTopoLive = "0";
        this.item.cropRodapeLive = "0";
        this.item.cropEsquerdaLive = "0";
        this.item.cropDireitaLive = "0";
        this.item.dispositivoVideo = "screen";
        this.item.dispositivoAudio = "false";

        this.item.eventoRemoto = "";
        this.item.eventosRemoto = [
          { id: "jogo1", nome: "Jogo 1" },
          { id: "62589562a2e2fb3009a986ff", nome: "WeddBets - teste 2" },
        ];

        if (
          this.retornaSite() == "7live" &&
          this.item.dispositivosAudio.length > 1
        ) {
          this.item.dispositivoAudio = this.item.dispositivosAudio[1]["id"];
        }

        for (var indiceCanal = 0; indiceCanal <= 20; indiceCanal++) {
          //* Define como padrao o canal definido no evento
          this.canais[indiceCanal.toString()] = {
            canal: indiceCanal.toString(),
            servidor: this.item.servidorTipo + "_" + this.item.servidor,
            status: false,
            enabled:
              this.item.servidorTipo == "ms" && indiceCanal > 1 ? false : true,
          };

          if (this.retornaSite() !== "7live" && itemEdit.transmissaoCanais) {
            if (itemEdit.transmissaoCanais[indiceCanal.toString()]) {
              if (itemEdit.transmissaoCanais[indiceCanal.toString()].servidor) {
                var servidorTransmissao = this.$global
                  .servidores_sip_array()
                  .filter(function (item) {
                    return (
                      item.id ==
                        itemEdit.transmissaoCanais[indiceCanal.toString()]
                          .servidor && item.id.startsWith(itemEdit.servidorTipo)
                    );
                  });

                if (servidorTransmissao.length > 0) {
                  this.canais[indiceCanal.toString()].servidor =
                    itemEdit.transmissaoCanais[indiceCanal.toString()].servidor;
                }
              }
            }
          }
        }

        if (this.item.servidorTipo == "sh") {
          apiFlashphoner.initStream();
        }

        if (
          this.retornaSite() == "Share" ||
          this.retornaSite() == "7live" ||
          this.item.servidorTipo == "ms2"
        ) {
          this.viewPreview = "not-preview";
        }

        document.title = "TR: " + itemEdit.nome;
      }
    },
    async carregarEventosRemoto() {
      const response = await api.get("/evento/remoto");
      this.$set(this.item, "eventosRemoto", response.data.itens);
    },
    async novo() {
      this.$set(this.item, "_id", "");
      this.$set(this.item, "nome", "");
      this.$set(this.item, "servidor", "");
      this.$set(this.item, "servidorTipo", "");
      this.$set(this.item, "rtmpLink", "-");
      this.$set(this.item, "rtmpChave", "-");
      this.$set(this.item, "linkFonte", "");
      this.$set(this.item, "ovToken", "");
      this.$set(this.item, "status", false);
      this.$set(this.item, "canal", "1");
      this.$set(this.item, "canalPrincipal", "");
      this.$set(this.item, "canalTransmissao", "0");
      this.$set(this.item, "cropTopo", "0");
      this.$set(this.item, "cropRodape", "0");
      this.$set(this.item, "cropEsquerda", "0");
      this.$set(this.item, "cropDireita", "0");
      this.$set(this.item, "cropTopoLive", "0");
      this.$set(this.item, "cropRodapeLive", "0");
      this.$set(this.item, "cropEsquerdaLive", "0");
      this.$set(this.item, "cropDireitaLive", "0");
      this.$set(this.item, "dispositivoVideo", "screen");
      this.$set(this.item, "dispositivoAudio", "false");
      this.$set(this.item, "eventoRemoto", "");
      this.$set(this.item, "eventosRemoto", []);
    },
    async transmissao(videoFiltro, canal) {
      var response;

      var itemEdit = {};

      var replyTo = [];

      if (
        this.$global.servidores_sip()[
          this.item.servidorTipo + "_" + this.item.servidor
        ].replyTo.length > 0
      ) {
        canal = "0";
        replyTo =
          this.$global.servidores_sip()[
            this.item.servidorTipo + "_" + this.item.servidor
          ].replyTo;
      }

      canal = canal.toString();

      //* Verifica se vai iniciar uma nova transmissao
      if (this.item.status == false) {
        var defineCanaisEvento;

        if (this.retornaSite() == "7live") {
          defineCanaisEvento =
            replyTo.length > 0 ? "&canais=" + replyTo.length : "&canais=1";
        }

        response = await api.get(
          "/evento/transmit/" +
            this.item._id +
            "?canal=" +
            canal +
            defineCanaisEvento +
            //(canalServidor ? "&canalServidor=" + canalServidor : "") +
            (videoFiltro ? "&videoFiltro=true" : "")
        );

        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      //* Verifica o tipo de servidor
      if (this.item.servidorTipo == "openvidu") {
        if (this.item.status == false) {
          //* Verifica se econtrou
          if (itemEdit.ovToken) {
            this.item.ovToken = itemEdit.ovToken;
            apiOpenVidu.entrarSessaoA(
              this.item.ovToken,
              this.item.dispositivoVideo,
              this.item.dispositivoAudio,
              canal
            );
          }
        } else {
          apiOpenVidu.fecharSessao(canal);
        }
      } else if (this.item.servidorTipo == "ant") {
        if (this.item.status == false) {
          var idCanal = itemEdit["_id"] + "_" + canal;

          console.log(itemEdit);

          if (
            itemEdit.logAnt[idCanal] &&
            itemEdit.logAnt[idCanal].publishTokenId
          ) {
            var arrServidor = itemEdit.servidor.split(":");

            this.$set(
              this.item,
              "rtmpLink",
              "rtmp:" + arrServidor[1] + "/WebRTCAppEE/"
            );
            this.$set(
              this.item,
              "rtmpChave",
              idCanal + "?token=" + itemEdit.logAnt[idCanal].publishTokenId
            );
          }
        }
      } else if (this.item.servidorTipo == "sh") {
        console.log("sh");
      } else if (this.item.servidorTipo == "ms") {
        if (this.item.status == false) {
          apiMS.setTipo("produtor");
          apiMS.setUrl(itemEdit.servidor);
          apiMS.setToken(itemEdit.msToken);
          apiMS.connect({});

          if (replyTo.length > 0) {
            for (
              var indiceReply = 0;
              indiceReply < replyTo.length;
              indiceReply++
            ) {
              var instaceDestServidor =
                replyTo[indiceReply].instanceDest.split("_");

              await api.get(
                "/evento/transmit/" +
                  this.item._id +
                  "?canal=" +
                  replyTo[indiceReply].canal +
                  "&servidor=" +
                  encodeURI(replyTo[indiceReply].instanceDest) +
                  (videoFiltro ? "&videoFiltro=true" : "")
              );

              replyTo[indiceReply].instanceDest = instaceDestServidor[1];
              replyTo[indiceReply].salaDest =
                this.item._id + "_" + replyTo[indiceReply].canal;
            }

            apiMS.setRoutes(replyTo);
          }

          this.msPublicar();
        } else {
          apiMS.closeProducer(this.item._id + "_" + canal);
          apiMS.disconnect();
        }
      }

      this.$set(this.item, "status", !this.item.status);
    },
    msPublicar() {
      if (apiMS.getConectado()) {
        apiMS.publish(
          this.item.dispositivoVideo,
          this.item.dispositivoAudio,
          this.viewPreview == "preview"
        );
      } else {
        var thisCall = this;
        setTimeout(function () {
          thisCall.msPublicar();
        }, 1000);
      }
    },
    msPublicarRemoto(instanceDest, salaDest, servidorFonte, eventoFonte) {
      if (apiMS.getConectado()) {
        apiMS.publishRouteRemoteReplication(
          instanceDest,
          salaDest,
          servidorFonte,
          eventoFonte
        );
      } else {
        var thisCall = this;
        setTimeout(function () {
          thisCall.msPublicarRemoto(
            instanceDest,
            salaDest,
            servidorFonte,
            eventoFonte
          );
        }, 1000);
      }
    },
    async transmissaoCanal(videoFiltro, canal) {
      var response;

      var itemEdit = {};

      //* Carrega os dados do servidor
      var servidor = this.canais[canal].servidor.split("_");

      //* Verifica se vai iniciar uma nova transmissao
      if (this.canais[canal].status == false) {
        response = await api.get(
          "/evento/transmit/" +
            this.item._id +
            "?servidor=" +
            encodeURI(this.canais[canal].servidor) +
            "&canal=" +
            canal +
            (videoFiltro ? "&videoFiltro=true" : "")
        );

        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      //* Verifica o tipo de servidor
      if (servidor[0] == "openvidu") {
        if (this.canais[canal].status == false) {
          //* Verifica se econtrou
          if (itemEdit.ovToken) {
            apiOpenVidu.entrarSessaoA(
              itemEdit.ovToken,
              this.item.dispositivoVideo,
              this.item.dispositivoAudio,
              canal
            );
            this.canais[canal].status = true;
            this.$forceUpdate();
          }
        } else {
          apiOpenVidu.fecharSessao(canal);
          this.canais[canal].status = false;
          this.$forceUpdate();
        }
      } else if (servidor[0] == "sh") {
        if (this.canais[canal].status == false) {
          apiFlashphoner.connectPublish(
            localStorage.getItem("ckd"),
            this.item,
            canal,
            this.item.dispositivoVideo,
            this.viewPreview == "preview"
          );
          this.canais[canal].status = true;
          this.$forceUpdate();
        } else {
          apiFlashphoner.stopStream(this.item, canal);
          this.canais[canal].status = false;
          this.$forceUpdate();
        }
      } else if (this.item.servidorTipo == "ms") {
        if (this.canais[canal].status == false) {
          var arrServidor = this.canais[canal].servidor.split("_");

          if (this.item.canalPrincipal == "") {
            this.item.canalPrincipal = canal;

            for (var keyCanal in this.canais) {
              this.canais[keyCanal].enabled = true;
            }

            if (this.item.canalPrincipal == "1") {
              this.canais["0"].enabled = false;
            }

            if (this.item.dispositivoVideo == "sharescreen") {
              apiMS.setTipo("produtor-remoto");
              apiMS.setUrl(arrServidor[1]);
              apiMS.setToken(itemEdit.msToken);
              apiMS.connect({});
            } else {
              apiMS.setTipo("produtor");
              apiMS.setUrl(arrServidor[1]);
              apiMS.setToken(itemEdit.msToken);
              apiMS.connect({});
              this.msPublicar();
            }
          } else {
            apiMS.publishRouteReplication(
              arrServidor[1],
              this.item._id + "_" + canal
            );
          }

          if (this.item.dispositivoVideo == "sharescreen") {
            //* Atualiza a lista de eventos remotos
            await this.carregarEventosRemoto();

            //* Percorre os eventos para verificar se ainda consta o selecionado
            var eventoRemoto = null;

            for (
              var indiceEventoRemoto = 0;
              indiceEventoRemoto < this.item.eventosRemoto.length;
              indiceEventoRemoto++
            ) {
              eventoRemoto = this.item.eventosRemoto[indiceEventoRemoto];

              if (eventoRemoto._id == this.item.eventoRemoto) {
                break;
              } else {
                eventoRemoto = null;
              }
            }

            //* Caso o evento ainda exista, envia o comando para replicar para o canal
            if (eventoRemoto !== null) {
              this.msPublicarRemoto(
                arrServidor[1],
                this.item._id + "_" + canal,
                eventoRemoto.servidor,
                this.item.eventoRemoto
              );
            } else {
              return;
            }
          }

          this.canais[canal].status = !this.canais[canal].status;
        } else {
          if (this.item.canalPrincipal == canal) {
            this.item.canalPrincipal = "";
            apiMS.closeProducer(this.item._id + "_" + canal);
            apiMS.disconnect();

            Object.entries(this.canais).forEach(([keyCanal]) => {
              this.canais[keyCanal].status = false;
              if (parseInt(keyCanal) > 1) {
                this.canais[keyCanal].enabled = false;
              } else {
                this.canais[keyCanal].enabled = true;
              }
            });
          } else {
            apiMS.closeProducer(this.item._id + "_" + canal);
            this.canais[canal].status = !this.canais[canal].status;
          }
        }

        this.$forceUpdate();
      }
    },
    async rtmp() {
      var itemEdit = {};

      this.$set(this.item, "rtmpLink", "-");
      this.$set(this.item, "rtmpChave", "-");

      var response = await api.get(
        "/evento/transmit/" + this.item._id + "?canal=" + this.item.canal
      );

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];

        var idCanal = itemEdit["_id"] + "_" + this.item.canal;

        if (
          itemEdit.logAnt[idCanal] &&
          itemEdit.logAnt[idCanal].publishTokenId
        ) {
          var arrServidor = itemEdit.servidor.split(":");

          this.$set(
            this.item,
            "rtmpLink",
            "rtmp:" + arrServidor[1] + "/WebRTCAppEE/"
          );
          this.$set(
            this.item,
            "rtmpChave",
            idCanal + "?token=" + itemEdit.logAnt[idCanal].publishTokenId
          );
        }
      }
    },
    async crop() {
      /*
      if (videoFiltro) {
        publishConfig["filter"] = {
          type: "GStreamerFilter",
          options: {
            command: "videocrop top=50 right=0 bottom=0",
          },
        };
      }*/

      /*
      apiOpenVidu.getPublisher().stream.applyFilter("FaceOverlayFilter").then(filter => {
          filter.execMethod(
              "setOverlayedImage",
              {
                  "uri":"https://cdn.pixabay.com/photo/2013/07/12/14/14/derby-148046_960_720.png",
                  "offsetXPercent":"-0.2F",
                  "offsetYPercent":"-0.8F",
                  "widthPercent":"10.3F",
                  "heightPercent":"10.0F"
              });
      });*/

      apiOpenVidu.getPublisher().stream.removeFilter();

      apiOpenVidu
        .getPublisher()
        .stream.applyFilter("GStreamerFilter", {
          command:
            "videocrop top=" +
            this.item.cropTopo +
            " bottom=" +
            this.item.cropRodape +
            " left=" +
            this.item.cropEsquerda +
            " right=" +
            this.item.cropDireita,
        })
        .then(() => {
          console.log("Video crop!");
        })
        .catch((error) => {
          console.error(error);
        });

      /*

        apiOpenVidu
        .getPublisher()
        .stream.applyFilter("GStreamerFilter", {
          command:
            "textoverlay text=\"Embedded text\" valignment=top halignment=right font-desc=\"Cantarell 25\"",
        })
        .then(() => {
          console.log("Video crop!");
        })
        .catch((error) => {
          console.error(error);
        });*/
    },
    novoCanal() {
      window.open(
        "/transmit/" + this.item._id,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=584,height=750",
        true
      );
    },
    abrirFonte() {
      window.open(
        this.item.linkFonte,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    abrirEvento(canal) {
      window.open(
        "/view/" + this.item._id + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    definirCompartilhamento() {
      this.item.previewAberto = true;
      apiOpenVidu.definirCompartilhamento(this.item.dispositivoVideo);
    },
    livePreview() {
      this.item.cropTopoLive = this.item.cropTopo;
      this.item.cropRodapeLive = this.item.cropRodape;
      this.item.cropEsquerdaLive = this.item.cropEsquerda;
      this.item.cropDireitaLive = this.item.cropDireita;
      apiOpenVidu.livePreview();
      this.item.abaTransmissaoVideo = "live";
      this.item.tabLive = true;
    },
    abaTransmissaoVideo(novaAba) {
      this.item.abaTransmissaoVideo = novaAba;
    },
    cropPreview(clear = false) {
      if (clear) {
        this.item.cropTopo = 0;
        this.item.cropRodape = 0;
        this.item.cropEsquerda = 0;
        this.item.cropDireita = 0;
      }

      apiOpenVidu.cropPreview(
        this.item.cropTopo,
        this.item.cropRodape,
        this.item.cropEsquerda,
        this.item.cropDireita
      );
    },
    cropLive(clear = false) {
      if (clear) {
        this.item.cropTopoLive = 0;
        this.item.cropRodapeLive = 0;
        this.item.cropEsquerdaLive = 0;
        this.item.cropDireitaLive = 0;
      }

      apiOpenVidu.cropLive(
        this.item.cropTopoLive,
        this.item.cropRodapeLive,
        this.item.cropEsquerdaLive,
        this.item.cropDireitaLive
      );
    },
    editarCanal(canal) {
      this.canalEdicao = canal;
    },
    alterarCanalServidor(servidor) {
      this.canais[this.canalEdicao].servidor = servidor;
      this.$forceUpdate();
    },
    apiFlashphoner() {
      return apiFlashphoner;
    },
  },
  async mounted() {
    this.view = this.propView;

    this.carregarItem(this.$route.params.id);

    this.item.dispositivosVideo.push({ id: "screen", nome: "Tela" });

    /*if (this.retornaSite() == "Weddbets") {
      this.item.dispositivosVideo.push({
        id: "sharescreen",
        nome: "Share Screen",
      });
    }*/

    this.item.dispositivosAudio.push({ id: "false", nome: "Sem áudio" });

    var openviduDevices = await apiOpenVidu.carregarDevices();

    for (
      var indiceDevice = 0;
      indiceDevice < openviduDevices.length;
      indiceDevice++
    ) {
      var openviduDevice = openviduDevices[indiceDevice];

      if (openviduDevice.kind == "videoinput") {
        this.item.dispositivosVideo.push({
          id: openviduDevice.deviceId,
          nome: openviduDevice.label,
        });
      }

      if (openviduDevice.kind == "audioinput") {
        this.item.dispositivosAudio.push({
          id: openviduDevice.deviceId,
          nome:
            openviduDevice.deviceId == "default"
              ? "Com áudio (Default)"
              : openviduDevice.label,
        });
      }
    }
  },
  data: function () {
    return {
      item: {
        _id: "",
        nome: "",
        servidor: "",
        servidorTipo: "",
        rtmpLink: "-",
        rtmpChave: "-",
        linkFonte: "",
        ovToken: "",
        status: false,
        canal: "1",
        canalPrincipal: "",
        canalTransmissao: "",
        cropTopo: "0",
        cropRodape: "0",
        cropEsquerda: "0",
        cropDireita: "0",
        cropTopoLive: "0",
        cropRodapeLive: "0",
        cropEsquerdaLive: "0",
        cropDireitaLive: "0",
        dispositivoVideo: "screen",
        dispositivoAudio: "false",
        dispositivosVideo: [],
        dispositivosAudio: [],
        eventoRemoto: "",
        eventosRemoto: [],
        previewAberto: false,
        abaTransmissaoVideo: "preview",
        tabLive: false,
        publisher: null,
      },
      servidores: {},
      canais: {},
      canalEdicao: "",
      viewPreview: "",
      avancado: false,
    };
  },
  computed: {
    servidoresTipo: function () {
      var arrFiltro = {};
      var arrServidores;
      var thisCall = this;

      if (parseInt(this.canalEdicao) > 0) {
        arrServidores = this.$global
          .servidores_sip_array()
          .filter(function (item) {
            return item.router == false;
          });
      } else {
        arrServidores = this.$global.servidores_sip_array().filter(function () {
          return (
            thisCall.item.servidorTipo == "openvidu" ||
            thisCall.item.servidorTipo == "ms"
          );
        });
      }

      var objServidores = {};

      arrServidores.filter(function (item) {
        objServidores[item.id] = item;
      });

      for (var keyItem in objServidores) {
        if (keyItem.startsWith(this.item.servidorTipo)) {
          arrFiltro[keyItem] = this.$global.servidores_sip()[keyItem];
        }
      }

      return arrFiltro;
    },
    servidoresRouter: function () {
      return this.$global.servidores_sip_array().filter(function (item) {
        return item.router == true;
      });
    },
    servidoresHabilitados: function () {
      return this.$global.servidores_sip_array().filter(function (item) {
        return item.router == false;
      });
    },
    dispositivosAudioObj: function () {
      return util.convertArrayToObject(this.item.dispositivosAudio, "id");
    },
  },
};
</script>

<style>
#app {
  margin-top: 10px;
}
</style>
